/* eslint-disable react/button-has-type,react/require-default-props,react/forbid-prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesome } from '../../FontAwesome';
import './Button.scss';

export const Button = (props) => {
  const {
    label,
    icon,
    colour,
    shape,
    large,
    iconProps,
    onClick,
    disabled,
    children,
    noFocusOutline,
    spacebar,
    type,
    className,
    textOnly,
    ...otherProps
  } = props;

  return (
    <react-button class={classNames({ spacebar }, className || '')}>
      <button
        {...{ onClick, disabled, type }}
        className={classNames(
          'btn',
          `react-button-${colour}`,
          `react-button-${shape}`,
          {
            center: !icon,
            large,
            spacebar,
            'no-blue-outline': noFocusOutline,
          },
          textOnly ? 'react-button-text-only' : ''
        )}
        {...otherProps}
      >
        {icon && <FontAwesome name={icon} {...iconProps} />}
        {label && <span>{label}</span>}
        {children}
      </button>
    </react-button>
  );
};
Button.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  colour: PropTypes.oneOf([
    'default',
    'square',
    'teal',
    'danger',
    'orange',
    'darkteal',
    'cta-pink',
    'white',
    'transparent',
    'kelp',
  ]),
  shape: PropTypes.oneOf(['default', 'square']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  iconProps: PropTypes.object,
  children: PropTypes.node,
  large: PropTypes.bool,
  noFocusOutline: PropTypes.bool,
  spacebar: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  className: PropTypes.string,
  textOnly: PropTypes.bool,
};
Button.defaultProps = {
  colour: 'default',
  shape: 'default',
  disabled: false,
  iconProps: {},
  textOnly: false,
};
